import { render, staticRenderFns } from "./XToManyList.vue?vue&type=template&id=19b3ba14"
import script from "./XToManyList.vue?vue&type=script&lang=js"
export * from "./XToManyList.vue?vue&type=script&lang=js"
import style0 from "./XToManyList.vue?vue&type=style&index=0&id=19b3ba14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports